import React from "react";
import { useNavigate } from "react-router-dom";

export const Mobile = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full w-full p-4 flex flex-col gap-4">
      <h1>Mobile Functions:</h1>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/");
        }}
      >
        Main Layout
      </button>

      <button
        className="btn btn-default"
        onClick={(e) => {
          navigate("/mobile/news");
        }}
      >
        News
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/tweets");
        }}
      >
        Tweets
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/reddit-analysis");
        }}
      >
        Reddit
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/reactions");
        }}
      >
        Reactions
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/twitter-realtime");
        }}
      >
        Twitter Real-time
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/clearcross");
        }}
      >
        ClearCross
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/expressions");
        }}
      >
        Keyword Tracer
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/event-candidates");
        }}
      >
        Event candidates
      </button>
 
      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/watchlist");
        }}
      >
        Watchlist
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/extended-watchlist");
        }}
      >
        Extended Watchlist
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/calendar");
        }}
      >
        Calendar
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/observations");
        }}
      >
        Observations
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/real-time-chart");
        }}
      >
        Real-time Chart
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/kk-comments");
        }}
      >
        KK Comments
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/realtime-notes");
        }}
      >
        Realtime Notes
      </button>

      <button
        className="btn btn-default"
        onClick={() => {
          navigate("/mobile/ibkr-chat");
        }}
      >
        IBKR chat
      </button>

    </div>
  );
};
